// extracted by mini-css-extract-plugin
export default {"searchFormMobile":"searchForm-module__searchFormMobile__47g6O","searchTabs":"searchForm-module__searchTabs__ekYVa","searchTabsMobile":"searchForm-module__searchTabsMobile__BW0BV"};